/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddLootBoxPrizeBody,
  AddLootBoxPrizeResponse,
  ApiError,
  CreateLootBoxConfigBody,
  CreateLootBoxConfigResponse,
  DeleteLootBoxPrizeResponse,
  GetActiveLootBoxConfigsResponse,
  GetLootBoxConfigPrizesResponse,
  GetLootBoxConfigResponse,
  GetLootBoxConfigsResponse,
  GetMyLootBoxInstancesResponse,
  GrantLootBoxInstanceBody,
  GrantLootBoxInstanceResponse,
  LootBoxPlacementContext,
  OpenLootBoxInstanceResponse,
  TimeFilter,
  UpdateLootBoxConfigBody,
  UpdateLootBoxConfigResponse,
  UpdateLootBoxPrizeBody,
  UpdateLootBoxPrizeResponse,
} from '../models/index';
import {
    AddLootBoxPrizeBodyFromJSON,
    AddLootBoxPrizeBodyToJSON,
    AddLootBoxPrizeResponseFromJSON,
    AddLootBoxPrizeResponseToJSON,
    ApiErrorFromJSON,
    ApiErrorToJSON,
    CreateLootBoxConfigBodyFromJSON,
    CreateLootBoxConfigBodyToJSON,
    CreateLootBoxConfigResponseFromJSON,
    CreateLootBoxConfigResponseToJSON,
    DeleteLootBoxPrizeResponseFromJSON,
    DeleteLootBoxPrizeResponseToJSON,
    GetActiveLootBoxConfigsResponseFromJSON,
    GetActiveLootBoxConfigsResponseToJSON,
    GetLootBoxConfigPrizesResponseFromJSON,
    GetLootBoxConfigPrizesResponseToJSON,
    GetLootBoxConfigResponseFromJSON,
    GetLootBoxConfigResponseToJSON,
    GetLootBoxConfigsResponseFromJSON,
    GetLootBoxConfigsResponseToJSON,
    GetMyLootBoxInstancesResponseFromJSON,
    GetMyLootBoxInstancesResponseToJSON,
    GrantLootBoxInstanceBodyFromJSON,
    GrantLootBoxInstanceBodyToJSON,
    GrantLootBoxInstanceResponseFromJSON,
    GrantLootBoxInstanceResponseToJSON,
    LootBoxPlacementContextFromJSON,
    LootBoxPlacementContextToJSON,
    OpenLootBoxInstanceResponseFromJSON,
    OpenLootBoxInstanceResponseToJSON,
    TimeFilterFromJSON,
    TimeFilterToJSON,
    UpdateLootBoxConfigBodyFromJSON,
    UpdateLootBoxConfigBodyToJSON,
    UpdateLootBoxConfigResponseFromJSON,
    UpdateLootBoxConfigResponseToJSON,
    UpdateLootBoxPrizeBodyFromJSON,
    UpdateLootBoxPrizeBodyToJSON,
    UpdateLootBoxPrizeResponseFromJSON,
    UpdateLootBoxPrizeResponseToJSON,
} from '../models/index';

export interface CreateLootboxConfigsRequest {
    createLootBoxConfigBody: CreateLootBoxConfigBody;
}

export interface CreateLootboxConfigsIdPrizesRequest {
    id: string;
    addLootBoxPrizeBody: AddLootBoxPrizeBody;
}

export interface CreateLootboxInstancesGrantRequest {
    grantLootBoxInstanceBody: GrantLootBoxInstanceBody;
}

export interface CreateLootboxInstancesIdOpenRequest {
    id: string;
    body?: object;
}

export interface DeleteLootboxConfigsIdRequest {
    id: string;
}

export interface DeleteLootboxConfigsIdPrizesPrizeIdRequest {
    id: string;
    prizeId: string;
}

export interface GetLootboxConfigsRequest {
    search?: string;
    isActive?: boolean;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetLootboxConfigsActiveRequest {
    context?: LootBoxPlacementContext;
}

export interface GetLootboxConfigsIdRequest {
    id: string;
}

export interface GetLootboxConfigsIdPrizesRequest {
    id: string;
}

export interface GetLootboxInstancesMineRequest {
    timeFilter?: TimeFilter;
    opened?: boolean;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface UpdateLootboxConfigsIdRequest {
    id: string;
    updateLootBoxConfigBody: UpdateLootBoxConfigBody;
}

export interface UpdateLootboxConfigsIdPrizesPrizeIdRequest {
    id: string;
    prizeId: string;
    updateLootBoxPrizeBody: UpdateLootBoxPrizeBody;
}

/**
 * LootBoxApi - interface
 * 
 * @export
 * @interface LootBoxApiInterface
 */
export interface LootBoxApiInterface {
    /**
     * Create a new virtual LootBox configuration
     * @param {CreateLootBoxConfigBody} createLootBoxConfigBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LootBoxApiInterface
     */
    createLootboxConfigsRaw(requestParameters: CreateLootboxConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLootBoxConfigResponse>>;

    /**
     * Create a new virtual LootBox configuration
     */
    createLootboxConfigs(requestParameters: CreateLootboxConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLootBoxConfigResponse>;

    /**
     * Add a prize to a LootBox configuration\'s prize pool
     * @param {string} id 
     * @param {AddLootBoxPrizeBody} addLootBoxPrizeBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LootBoxApiInterface
     */
    createLootboxConfigsIdPrizesRaw(requestParameters: CreateLootboxConfigsIdPrizesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddLootBoxPrizeResponse>>;

    /**
     * Add a prize to a LootBox configuration\'s prize pool
     */
    createLootboxConfigsIdPrizes(requestParameters: CreateLootboxConfigsIdPrizesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddLootBoxPrizeResponse>;

    /**
     * Grant a LootBox instance to a user (admin)
     * @param {GrantLootBoxInstanceBody} grantLootBoxInstanceBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LootBoxApiInterface
     */
    createLootboxInstancesGrantRaw(requestParameters: CreateLootboxInstancesGrantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GrantLootBoxInstanceResponse>>;

    /**
     * Grant a LootBox instance to a user (admin)
     */
    createLootboxInstancesGrant(requestParameters: CreateLootboxInstancesGrantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GrantLootBoxInstanceResponse>;

    /**
     * Open a LootBox instance to reveal and distribute a prize
     * @param {string} id 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LootBoxApiInterface
     */
    createLootboxInstancesIdOpenRaw(requestParameters: CreateLootboxInstancesIdOpenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OpenLootBoxInstanceResponse>>;

    /**
     * Open a LootBox instance to reveal and distribute a prize
     */
    createLootboxInstancesIdOpen(requestParameters: CreateLootboxInstancesIdOpenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OpenLootBoxInstanceResponse>;

    /**
     * Delete a LootBox configuration. Fails if any instances (opened or unopened) exist.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LootBoxApiInterface
     */
    deleteLootboxConfigsIdRaw(requestParameters: DeleteLootboxConfigsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a LootBox configuration. Fails if any instances (opened or unopened) exist.
     */
    deleteLootboxConfigsId(requestParameters: DeleteLootboxConfigsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Remove a prize from a LootBox configuration
     * @param {string} id 
     * @param {string} prizeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LootBoxApiInterface
     */
    deleteLootboxConfigsIdPrizesPrizeIdRaw(requestParameters: DeleteLootboxConfigsIdPrizesPrizeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteLootBoxPrizeResponse>>;

    /**
     * Remove a prize from a LootBox configuration
     */
    deleteLootboxConfigsIdPrizesPrizeId(requestParameters: DeleteLootboxConfigsIdPrizesPrizeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteLootBoxPrizeResponse>;

    /**
     * List all LootBox configurations (admin)
     * @param {string} [search] 
     * @param {boolean} [isActive] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LootBoxApiInterface
     */
    getLootboxConfigsRaw(requestParameters: GetLootboxConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLootBoxConfigsResponse>>;

    /**
     * List all LootBox configurations (admin)
     */
    getLootboxConfigs(requestParameters: GetLootboxConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLootBoxConfigsResponse>;

    /**
     * Get all currently active LootBox configurations, optionally filtered by placement context
     * @param {LootBoxPlacementContext} [context] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LootBoxApiInterface
     */
    getLootboxConfigsActiveRaw(requestParameters: GetLootboxConfigsActiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetActiveLootBoxConfigsResponse>>;

    /**
     * Get all currently active LootBox configurations, optionally filtered by placement context
     */
    getLootboxConfigsActive(requestParameters: GetLootboxConfigsActiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetActiveLootBoxConfigsResponse>;

    /**
     * Get a single LootBox configuration by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LootBoxApiInterface
     */
    getLootboxConfigsIdRaw(requestParameters: GetLootboxConfigsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLootBoxConfigResponse>>;

    /**
     * Get a single LootBox configuration by ID
     */
    getLootboxConfigsId(requestParameters: GetLootboxConfigsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLootBoxConfigResponse>;

    /**
     * Get the public prize preview for a LootBox config, with remaining quantities
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LootBoxApiInterface
     */
    getLootboxConfigsIdPrizesRaw(requestParameters: GetLootboxConfigsIdPrizesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLootBoxConfigPrizesResponse>>;

    /**
     * Get the public prize preview for a LootBox config, with remaining quantities
     */
    getLootboxConfigsIdPrizes(requestParameters: GetLootboxConfigsIdPrizesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLootBoxConfigPrizesResponse>;

    /**
     * Get the authenticated user\'s LootBox instances, optionally filtered by open/unopened state and time range
     * @param {TimeFilter} [timeFilter] 
     * @param {boolean} [opened] Filter by opened state — \&#39;true\&#39; for opened instances, \&#39;false\&#39; for unopened
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LootBoxApiInterface
     */
    getLootboxInstancesMineRaw(requestParameters: GetLootboxInstancesMineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMyLootBoxInstancesResponse>>;

    /**
     * Get the authenticated user\'s LootBox instances, optionally filtered by open/unopened state and time range
     */
    getLootboxInstancesMine(requestParameters: GetLootboxInstancesMineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMyLootBoxInstancesResponse>;

    /**
     * Update a LootBox configuration
     * @param {string} id 
     * @param {UpdateLootBoxConfigBody} updateLootBoxConfigBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LootBoxApiInterface
     */
    updateLootboxConfigsIdRaw(requestParameters: UpdateLootboxConfigsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateLootBoxConfigResponse>>;

    /**
     * Update a LootBox configuration
     */
    updateLootboxConfigsId(requestParameters: UpdateLootboxConfigsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateLootBoxConfigResponse>;

    /**
     * Update a prize within a LootBox configuration
     * @param {string} id 
     * @param {string} prizeId 
     * @param {UpdateLootBoxPrizeBody} updateLootBoxPrizeBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LootBoxApiInterface
     */
    updateLootboxConfigsIdPrizesPrizeIdRaw(requestParameters: UpdateLootboxConfigsIdPrizesPrizeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateLootBoxPrizeResponse>>;

    /**
     * Update a prize within a LootBox configuration
     */
    updateLootboxConfigsIdPrizesPrizeId(requestParameters: UpdateLootboxConfigsIdPrizesPrizeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateLootBoxPrizeResponse>;

}

/**
 * 
 */
export class LootBoxApi extends runtime.BaseAPI implements LootBoxApiInterface {

    /**
     * Create a new virtual LootBox configuration
     */
    async createLootboxConfigsRaw(requestParameters: CreateLootboxConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLootBoxConfigResponse>> {
        if (requestParameters['createLootBoxConfigBody'] == null) {
            throw new runtime.RequiredError(
                'createLootBoxConfigBody',
                'Required parameter "createLootBoxConfigBody" was null or undefined when calling createLootboxConfigs().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/lootbox-configs`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLootBoxConfigBodyToJSON(requestParameters['createLootBoxConfigBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLootBoxConfigResponseFromJSON(jsonValue));
    }

    /**
     * Create a new virtual LootBox configuration
     */
    async createLootboxConfigs(requestParameters: CreateLootboxConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLootBoxConfigResponse> {
        const response = await this.createLootboxConfigsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a prize to a LootBox configuration\'s prize pool
     */
    async createLootboxConfigsIdPrizesRaw(requestParameters: CreateLootboxConfigsIdPrizesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddLootBoxPrizeResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createLootboxConfigsIdPrizes().'
            );
        }

        if (requestParameters['addLootBoxPrizeBody'] == null) {
            throw new runtime.RequiredError(
                'addLootBoxPrizeBody',
                'Required parameter "addLootBoxPrizeBody" was null or undefined when calling createLootboxConfigsIdPrizes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/lootbox-configs/{id}/prizes`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddLootBoxPrizeBodyToJSON(requestParameters['addLootBoxPrizeBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddLootBoxPrizeResponseFromJSON(jsonValue));
    }

    /**
     * Add a prize to a LootBox configuration\'s prize pool
     */
    async createLootboxConfigsIdPrizes(requestParameters: CreateLootboxConfigsIdPrizesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddLootBoxPrizeResponse> {
        const response = await this.createLootboxConfigsIdPrizesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Grant a LootBox instance to a user (admin)
     */
    async createLootboxInstancesGrantRaw(requestParameters: CreateLootboxInstancesGrantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GrantLootBoxInstanceResponse>> {
        if (requestParameters['grantLootBoxInstanceBody'] == null) {
            throw new runtime.RequiredError(
                'grantLootBoxInstanceBody',
                'Required parameter "grantLootBoxInstanceBody" was null or undefined when calling createLootboxInstancesGrant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/lootbox-instances/grant`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GrantLootBoxInstanceBodyToJSON(requestParameters['grantLootBoxInstanceBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GrantLootBoxInstanceResponseFromJSON(jsonValue));
    }

    /**
     * Grant a LootBox instance to a user (admin)
     */
    async createLootboxInstancesGrant(requestParameters: CreateLootboxInstancesGrantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GrantLootBoxInstanceResponse> {
        const response = await this.createLootboxInstancesGrantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Open a LootBox instance to reveal and distribute a prize
     */
    async createLootboxInstancesIdOpenRaw(requestParameters: CreateLootboxInstancesIdOpenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OpenLootBoxInstanceResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createLootboxInstancesIdOpen().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/lootbox-instances/{id}/open`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OpenLootBoxInstanceResponseFromJSON(jsonValue));
    }

    /**
     * Open a LootBox instance to reveal and distribute a prize
     */
    async createLootboxInstancesIdOpen(requestParameters: CreateLootboxInstancesIdOpenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OpenLootBoxInstanceResponse> {
        const response = await this.createLootboxInstancesIdOpenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a LootBox configuration. Fails if any instances (opened or unopened) exist.
     */
    async deleteLootboxConfigsIdRaw(requestParameters: DeleteLootboxConfigsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteLootboxConfigsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/lootbox-configs/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a LootBox configuration. Fails if any instances (opened or unopened) exist.
     */
    async deleteLootboxConfigsId(requestParameters: DeleteLootboxConfigsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteLootboxConfigsIdRaw(requestParameters, initOverrides);
    }

    /**
     * Remove a prize from a LootBox configuration
     */
    async deleteLootboxConfigsIdPrizesPrizeIdRaw(requestParameters: DeleteLootboxConfigsIdPrizesPrizeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteLootBoxPrizeResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteLootboxConfigsIdPrizesPrizeId().'
            );
        }

        if (requestParameters['prizeId'] == null) {
            throw new runtime.RequiredError(
                'prizeId',
                'Required parameter "prizeId" was null or undefined when calling deleteLootboxConfigsIdPrizesPrizeId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/lootbox-configs/{id}/prizes/{prizeId}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"prizeId"}}`, encodeURIComponent(String(requestParameters['prizeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteLootBoxPrizeResponseFromJSON(jsonValue));
    }

    /**
     * Remove a prize from a LootBox configuration
     */
    async deleteLootboxConfigsIdPrizesPrizeId(requestParameters: DeleteLootboxConfigsIdPrizesPrizeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteLootBoxPrizeResponse> {
        const response = await this.deleteLootboxConfigsIdPrizesPrizeIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all LootBox configurations (admin)
     */
    async getLootboxConfigsRaw(requestParameters: GetLootboxConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLootBoxConfigsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['isActive'] != null) {
            queryParameters['isActive'] = requestParameters['isActive'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/lootbox-configs`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLootBoxConfigsResponseFromJSON(jsonValue));
    }

    /**
     * List all LootBox configurations (admin)
     */
    async getLootboxConfigs(requestParameters: GetLootboxConfigsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLootBoxConfigsResponse> {
        const response = await this.getLootboxConfigsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all currently active LootBox configurations, optionally filtered by placement context
     */
    async getLootboxConfigsActiveRaw(requestParameters: GetLootboxConfigsActiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetActiveLootBoxConfigsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['context'] != null) {
            queryParameters['context'] = requestParameters['context'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/lootbox-configs/active`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetActiveLootBoxConfigsResponseFromJSON(jsonValue));
    }

    /**
     * Get all currently active LootBox configurations, optionally filtered by placement context
     */
    async getLootboxConfigsActive(requestParameters: GetLootboxConfigsActiveRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetActiveLootBoxConfigsResponse> {
        const response = await this.getLootboxConfigsActiveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a single LootBox configuration by ID
     */
    async getLootboxConfigsIdRaw(requestParameters: GetLootboxConfigsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLootBoxConfigResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getLootboxConfigsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/lootbox-configs/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLootBoxConfigResponseFromJSON(jsonValue));
    }

    /**
     * Get a single LootBox configuration by ID
     */
    async getLootboxConfigsId(requestParameters: GetLootboxConfigsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLootBoxConfigResponse> {
        const response = await this.getLootboxConfigsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the public prize preview for a LootBox config, with remaining quantities
     */
    async getLootboxConfigsIdPrizesRaw(requestParameters: GetLootboxConfigsIdPrizesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLootBoxConfigPrizesResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getLootboxConfigsIdPrizes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/lootbox-configs/{id}/prizes`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLootBoxConfigPrizesResponseFromJSON(jsonValue));
    }

    /**
     * Get the public prize preview for a LootBox config, with remaining quantities
     */
    async getLootboxConfigsIdPrizes(requestParameters: GetLootboxConfigsIdPrizesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLootBoxConfigPrizesResponse> {
        const response = await this.getLootboxConfigsIdPrizesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the authenticated user\'s LootBox instances, optionally filtered by open/unopened state and time range
     */
    async getLootboxInstancesMineRaw(requestParameters: GetLootboxInstancesMineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMyLootBoxInstancesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['timeFilter'] != null) {
            queryParameters['timeFilter'] = requestParameters['timeFilter'];
        }

        if (requestParameters['opened'] != null) {
            queryParameters['opened'] = requestParameters['opened'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/lootbox-instances/mine`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMyLootBoxInstancesResponseFromJSON(jsonValue));
    }

    /**
     * Get the authenticated user\'s LootBox instances, optionally filtered by open/unopened state and time range
     */
    async getLootboxInstancesMine(requestParameters: GetLootboxInstancesMineRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMyLootBoxInstancesResponse> {
        const response = await this.getLootboxInstancesMineRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a LootBox configuration
     */
    async updateLootboxConfigsIdRaw(requestParameters: UpdateLootboxConfigsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateLootBoxConfigResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateLootboxConfigsId().'
            );
        }

        if (requestParameters['updateLootBoxConfigBody'] == null) {
            throw new runtime.RequiredError(
                'updateLootBoxConfigBody',
                'Required parameter "updateLootBoxConfigBody" was null or undefined when calling updateLootboxConfigsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/lootbox-configs/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLootBoxConfigBodyToJSON(requestParameters['updateLootBoxConfigBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateLootBoxConfigResponseFromJSON(jsonValue));
    }

    /**
     * Update a LootBox configuration
     */
    async updateLootboxConfigsId(requestParameters: UpdateLootboxConfigsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateLootBoxConfigResponse> {
        const response = await this.updateLootboxConfigsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a prize within a LootBox configuration
     */
    async updateLootboxConfigsIdPrizesPrizeIdRaw(requestParameters: UpdateLootboxConfigsIdPrizesPrizeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateLootBoxPrizeResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateLootboxConfigsIdPrizesPrizeId().'
            );
        }

        if (requestParameters['prizeId'] == null) {
            throw new runtime.RequiredError(
                'prizeId',
                'Required parameter "prizeId" was null or undefined when calling updateLootboxConfigsIdPrizesPrizeId().'
            );
        }

        if (requestParameters['updateLootBoxPrizeBody'] == null) {
            throw new runtime.RequiredError(
                'updateLootBoxPrizeBody',
                'Required parameter "updateLootBoxPrizeBody" was null or undefined when calling updateLootboxConfigsIdPrizesPrizeId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/lootbox-configs/{id}/prizes/{prizeId}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"prizeId"}}`, encodeURIComponent(String(requestParameters['prizeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLootBoxPrizeBodyToJSON(requestParameters['updateLootBoxPrizeBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateLootBoxPrizeResponseFromJSON(jsonValue));
    }

    /**
     * Update a prize within a LootBox configuration
     */
    async updateLootboxConfigsIdPrizesPrizeId(requestParameters: UpdateLootboxConfigsIdPrizesPrizeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateLootBoxPrizeResponse> {
        const response = await this.updateLootboxConfigsIdPrizesPrizeIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
